import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import { NavLink, withRouter } from 'react-router-dom'
import LogoLavoratore from '../../../assets/logo-lavoratore.png'
import LogoResidente from '../../../assets/logo-residente.png'
import Loading from '../../../components/LoadingComponent'
import queryString from 'query-string'
import './RegistrationCategoriesChooser.css'

class RegistrationCategoriesChooser extends Component {
  static propTypes = {
    match: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      categories: [],
      id: null
    }

    this.renderCategory = this.renderCategory.bind(this)
    this.fetchCategories = this.fetchCategories.bind(this)
  }

  async fetchCategories (id) {
    this.setState({loading: true})
    if (id) {
      const category = await SostaOnlineApiService.fetchUserCategoryById(id)
      this.setState({categories: [category.data], loading: false, id: id})
    } else {
      const categories = await SostaOnlineApiService.fetchUserCategories()
      this.setState({categories: categories.data, loading: false, id: null})
    }
  }

  componentWillMount () {
    this.fetchCategories(this.props.match.params.id)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchCategories(this.props.match.params.id)
    }
  }

  renderCategory (category, index, parentMode = true) {
    const { match } = this.props

    if (parentMode) {
      return (<div key={index} className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div className="panel registration-box panel-default panel-border-login">
          <div className="registration-box-content">
            <div className="registration-title registration-box-title">{category.name}</div>
            <div className="panel-body registration-box-body">
              <a href="#" className="btn-social btn-outline">
                {/*<img className="login-admin-logo" src={LogoLavoratore} />*/}
              </a>
              {/* <br /> */}
              {/* <div className="panel-body flex-grow panel-2">
                <div className="title-registration-box">
                  {category.name}
                </div>
                <div className="subtitle-registration-box">
                  {category.description}
                </div>
              </div> */}
              {category.Children.length === 0 && <NavLink
                style={{display: 'block'}}
                className="resident-btn-navlink splash-login-btn"
                to={'/register/user-info/' + category.id}>
                <strong>REGISTRATI</strong> <span className="glyphicon glyphicon-arrow-right">{}</span>
              </NavLink>}
              {category.Children.length > 0 && <NavLink
                style={{display: 'block'}}
                className="resident-btn-navlink splash-login-btn"
                to={'/register/choose-category/' + category.id}>
                <strong>AVANTI</strong> <span className="glyphicon glyphicon-arrow-right">{}</span>
              </NavLink>}
            </div>
          </div>
        </div>
      </div>)
    } else {
      return (<div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div className="panel panel-default panel-border">
          <div className="panel-body text-left">
            <h3 className="title3">{category.name}</h3>
            <div className="panel-body flex-grow panel-2">
              {category.description}
            </div>
            <NavLink className="panel-footer register-footer btn-green btn-block" to={'/register/worker/employees'}>
              VAI <span className="glyphicon glyphicon-arrow-right">{}</span>
            </NavLink>
          </div>
        </div>
      </div>)
    }
  }

  render () {
    const { match } = this.props
    const { categories, loading, id } = this.state

    if (loading) {
      return (<Loading />)
    }

    return (<div>
      {id && categories[0].Children.map((item, index) => {
        return this.renderCategory(item, index)
      })}

      {!id && categories.map((item, index) => {
        return this.renderCategory(item, index, true)
      })}
    </div>)
  }
}

export default withRouter(RegistrationCategoriesChooser)



// WEBPACK FOOTER //
// ./src/containers/Registration/RegistrationCategoriesChooser/RegistrationCategoriesChooser.js